import { render, staticRenderFns } from "./Protection_of_rights_and_interests.vue?vue&type=template&id=0eaaf085&scoped=true"
import script from "./Protection_of_rights_and_interests.vue?vue&type=script&lang=js"
export * from "./Protection_of_rights_and_interests.vue?vue&type=script&lang=js"
import style0 from "./Protection_of_rights_and_interests.vue?vue&type=style&index=0&id=0eaaf085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaaf085",
  null
  
)

export default component.exports